import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getTeamsList() {
    return axios.get(APP_SETTINGS.API_PATH.TEAMS.getAllTeams);
}

export function addTeam(teamData) {
    return axios.post(APP_SETTINGS.API_PATH.TEAMS.addNewTeam, teamData);
}

export function removeTeam(teamId) {
    return axios.post(APP_SETTINGS.API_PATH.TEAMS.deleteTeam, {
        "requestId": teamId
    });
}